export default __webpack_public_path__ + "static/media/best-piano.cbffa8b9.png";